import script from "./OrderPlanProductDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPlanProductDetail.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPlanProductDetail.vue?vue&type=style&index=0&id=a7c82e12&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7c82e12"]])

export default __exports__